<div class="kf-picker">
  <div class="kf-picker-card">
    <div class="kf-picker-header">
      <h2>Select a company</h2>
      <p>
        @if (loading()) {
          Loading the companies you can access…
        } @else {
          Choose the company to work in.
        }
      </p>
    </div>

    @if (error()) {
      <div class="kf-picker-error">{{ error() }}</div>
      <button nz-button nzType="default" nzBlock (click)="load()">Try again</button>
    }

    @if (!loading() && !error()) {
      <div class="kf-picker-list">
        @for (tenant of tenants(); track tenant.TenantCompanyId) {
          <div
            class="kf-tenant"
            [class.selected]="selected()?.TenantCompanyId === tenant.TenantCompanyId"
            (click)="pick(tenant)"
          >
            <div class="kf-tenant-icon" [style.background-color]="color(tenant.UnitType)">
              <span nz-icon nzType="bank" nzTheme="outline"></span>
            </div>
            <div class="kf-tenant-info">
              <div class="kf-tenant-name">{{ tenant.CompanyName }}</div>
              <div class="kf-tenant-meta">
                <nz-tag [nzColor]="color(tenant.UnitType)">{{ label(tenant.UnitType) }}</nz-tag>
                <span class="kf-tenant-code">{{ tenant.CompanyCode }}</span>
                @if (tenant.IsPrimaryTenant) {
                  <nz-tag nzColor="gold">Primary</nz-tag>
                }
              </div>
            </div>
            <div class="kf-tenant-actions">
              @if (selected()?.TenantCompanyId === tenant.TenantCompanyId) {
                <span nz-icon nzType="check-circle" nzTheme="fill" class="kf-tenant-check"></span>
              }
              @if (hasMultiple() && !tenant.IsPrimaryTenant) {
                <button nz-button nzType="link" nzSize="small" [nzLoading]="savingPrimary()"
                  (click)="setPrimary(tenant, $event)" nz-tooltip nzTooltipTitle="Set as primary — preselected next time">
                  <span nz-icon nzType="star" nzTheme="outline"></span>
                </button>
              }
            </div>
          </div>
        }
      </div>

      <div class="kf-picker-footer">
        <button nz-button nzType="primary" nzSize="large" nzBlock [disabled]="!canContinue()"
          [nzLoading]="opening()" (click)="continue()">
          Continue
        </button>
        @if (hasMultiple() && hasPrimary()) {
          <button nz-button nzType="text" nzSize="small" [nzLoading]="savingPrimary()" (click)="setPrimary(null, $event)"
            nz-tooltip nzTooltipTitle="You will be asked to choose each time">
            <span nz-icon nzType="close-circle" nzTheme="outline"></span>
            Clear primary
          </button>
        }
      </div>
    }
  </div>
</div>
